import { Controller } from 'react-hook-form';

import { FaceIdProfileService } from '@/services';
import { getProfileOptionLabel, mapFaceIdProfileResponseToMultiSelectOptions } from '@/utils';

import {
  IAllowedMembersSection,
  IIpadConfigDetails,
  IPAD_CONFIG_FORM_FIELDS,
} from '@/features/ipad-configs';
import MultiSelect from '@/components/common/MultiSelect/MultiSelect';

const AllowedMembersSection = ({
  control,
  errors,
  defaultValues,
}: IAllowedMembersSection & {
  defaultValues: IIpadConfigDetails;
}) => {
  return (
    <div className="flex flex-col gap-6">
      <h5 className="font-bold text-h5 text-brand-primary-darkest">Allowed Members</h5>
      <Controller
        name={IPAD_CONFIG_FORM_FIELDS.allowMembers}
        control={control}
        render={({ field }) => (
          <MultiSelect
            label="Face Profile ID"
            placeholder="Select Face Profile ID"
            defaultCacheOptions={defaultValues.members?.map((member) => ({
              label: getProfileOptionLabel(
                member.profileId,
                member.fullName,
                member.profileId.replace('FID', ''),
              ),
              value: member.id,
            }))}
            defaultValue={field.value}
            onValueChange={field.onChange}
            maxCount={-1}
            hideSelectAll
            searchCallback={async (searchValue) =>
              mapFaceIdProfileResponseToMultiSelectOptions(
                await FaceIdProfileService.GetFaceIdProfiles(searchValue),
              )
            }
            required
            error={errors[IPAD_CONFIG_FORM_FIELDS.allowMembers]?.message}
            isLabelstyled
          />
        )}
      />
      <div className="w-full h-px bg-neutral-n3"></div>
    </div>
  );
};

export default AllowedMembersSection;
